import { config } from "JS/Config";
import { BaseService } from "../BaseService";
import { BundleSubscription } from "JS/Models/BundleSubscription";
import { appConstants } from "JS/Helpers/Constants";

export class BundleSubscriptionService extends BaseService {
    getBundleSubscriptionStatus = () =>
        this.ngCall<BundleSubscription>(
            "get",
            appConstants.ngEndpoints.getBundleSubscriptionStatus(
                config.user.memberId,
            ),
        );
}
